import React from "react";
import { PRICING_GROUPS, PRICING_START_TRIAL_CTA } from "../../../config/marketing/pricing";
import Section from "../../../components/layout/marketing/Section";
import FeatureColumn from "../components/PricingFeature";
import { Button } from "../../../components/common/button";
import Chip from "../../../components/common/chip";

export default function PricingSection() {
    const handleStartTrial = () => {
        const url = PRICING_START_TRIAL_CTA;
        window.open(url, "_blank", "noopener,noreferrer");
    };
    return (
        <Section
            id="pricing"
            className="relative text-white bg-[linear-gradient(90deg,rgb(var(--brand-end))_0%,rgb(var(--brand-start))_100%)]"
        >
            <div className="pointer-events-none absolute inset-0">
                <div className="absolute inset-0 bg-[linear-gradient(180deg,transparent_0%,transparent_45%,#ffffff_55%,#ffffff_100%)]" />
            </div>

            {/* Content */}
            <div className="relative">
                {/* Header */}
                <div className="mx-auto max-w-3xl text-center">
                    <Chip>Pricing</Chip>
                    <h2 className="mt-3 text-3xl font-semibold md:text-5xl tracking-tight">
                        One plan, everything included
                    </h2>
                    <p className="mt-3 text-lg text-white/80">Transparent pricing for practices of all sizes.</p>
                </div>

                {/* Feature Card */}
                <div className="mx-auto mt-12 max-w-7xl rounded-2xl bg-bg-page p-8 shadow-xl md:p-12">
                    <div className="grid gap-12 md:grid-cols-3">
                        {PRICING_GROUPS.map((group) => (
                            <FeatureColumn key={group.title} group={group} />
                        ))}
                    </div>

                    {/* Footer */}
                    <div className="mt-14 border-t pt-10 text-center">
                        <h3 className="text-2xl md:text-4xl font-semibold tracking-tight text-text-primary">
                            Eikos Health Doesn’t Cost, It Gives Back.
                        </h3>

                        <p className="mx-auto mt-2 max-w-2xl md:text-2xl text-base leading-tight md:tracking-tight text-text-secondary">
                            Experience a solution that returns more productive hours and saves more money than it costs
                            to run.
                        </p>

                        <div className="mt-8 flex items-end justify-center gap-6">
                            <div className="text-center">
                                <p className="text-xs text-text-muted">Quarterly</p>
                                <p className="text-xl md:text-5xl font-semibold text-text-primary">
                                    ₹999
                                    <span className="text-sm font-normal text-text-muted">/month</span>
                                </p>
                            </div>

                            <span className="text-sm text-text-muted">or</span>

                            <div className="text-center">
                                <p className="text-xs text-primary font-semibold">Annual · Save 17%</p>
                                <p className="text-xl md:text-5xl font-semibold text-text-primary">
                                    ₹833
                                    <span className="text-sm font-normal text-text-muted">/month</span>
                                </p>
                            </div>
                        </div>

                        <div className="mt-8 flex justify-center">
                            <Button variant="primaryGlow" size="lg" onClick={handleStartTrial}>
                                Start Free Trial
                            </Button>
                        </div>

                        <p className="mt-4 text-xs text-text-muted">No credit card required · Full access for 7 days</p>
                    </div>
                </div>
            </div>
        </Section>
    );
}
